// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Welcome_welcome__3t1S_","message":"Welcome_message__1-KnZ"};